import React from 'react';

import PropTypes from 'prop-types';
import Translate from '../../../../utils/Translate';

import GhostButton from '../../GhostButton/GhostButton';
import LinkButton from '../../LinkButton/LinkButton';
import Navigator from '../../../../utils/Navigator';

import './NavButtons.css';

export const NavButtons = ({
  isLoading,
  isDisabled,
  isCancelEnabled,
  onClick,
  onClickCancel
}) => (
  <div className="nav-buttons-container -eva-3-mt-lg">
    <div className="-eva-3-pr-xlg">
      <div className="-eva-3-center">
        <GhostButton
          disable={isDisabled}
          onClick={onClick}
          loading={isLoading}
          text={Translate.message('Continuar')}
        />
      </div>
    </div>

    {
      isCancelEnabled &&
      <div>
        <LinkButton
          onClick={onClickCancel}
          linkTo={Navigator.addEmailPage}
          text={Translate.message('Cancelar')}
          medium
          className="-eva-3-center"
        />
      </div>
    }
  </div>
);

NavButtons.defaultProps = {
  onClickCancel: () => {}
};

NavButtons.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isCancelEnabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onClickCancel: PropTypes.func,
};
